import * as _ from 'lodash';
import { stringSimilarity } from "string-similarity-js";
import { useTeamLogos } from './team';

const data = [
  {
    name: 'AIK',
    homeMatch: 12,
    mostSpectators: 41327,
    highestMatch: 'Djurgården - 2023-09-24',
    highestWeekday: 'Sunday',
    highestMatchId: '5391452',
    highestHomeTeamName: 'AIK',
    highestHomeTeamExtID: 66036,
    highestAwayTeamName: 'Djurgården',
    highestAwayTeamExtID: 89483,
    highestDate: '2023-09-24T13:00:00.000Z',
    leastSpectators: 19164,
    lowestMatch: 'Varbergs BoIS FC - 2023-08-28',
    lowestWeekday: 'Monday',
    lowestMatchId: '5391428',
    lowestHomeTeamName: 'AIK',
    lowestHomeTeamExtID: 66036,
    lowestAwayTeamName: 'Varbergs BoIS FC',
    lowestAwayTeamExtID: 26111,
    lowestDate: '2023-08-28T17:00:00.000Z',
    average: 26076,
    totalHome: 312916,
    totalAway: 135646,
  },
  {
    name: 'Hammarby',
    homeMatch: 11,
    mostSpectators: 30941,
    highestMatch: 'Degerfors IF - 2023-04-02',
    highestWeekday: 'Sunday',
    highestMatchId: '5391254',
    highestHomeTeamName: 'Hammarby',
    highestHomeTeamExtID: 66592,
    highestAwayTeamName: 'Degerfors IF',
    highestAwayTeamExtID: 25640,
    highestDate: '2023-04-02T13:00:00.000Z',
    leastSpectators: 19243,
    lowestMatch: 'IF Brommapojkarna - 2023-06-09',
    lowestWeekday: 'Friday',
    lowestMatchId: '5391358',
    lowestHomeTeamName: 'Hammarby',
    lowestHomeTeamExtID: 66592,
    lowestAwayTeamName: 'IF Brommapojkarna',
    lowestAwayTeamExtID: 25591,
    lowestDate: '2023-06-09T17:00:00.000Z',
    average: 23379,
    totalHome: 257173,
    totalAway: 152570,
  },
  {
    name: 'Malmö FF',
    homeMatch: 12,
    mostSpectators: 21312,
    highestMatch: 'Kalmar FF - 2023-04-01',
    highestWeekday: 'Saturday',
    highestMatchId: '5391256',
    highestHomeTeamName: 'Malmö FF',
    highestHomeTeamExtID: 25517,
    highestAwayTeamName: 'Kalmar FF',
    highestAwayTeamExtID: 25521,
    highestDate: '2023-04-01T13:00:00.000Z',
    leastSpectators: 17116,
    lowestMatch: 'Halmstad - 2023-08-07',
    lowestWeekday: 'Monday',
    lowestMatchId: '5391405',
    lowestHomeTeamName: 'Malmö FF',
    lowestHomeTeamExtID: 25517,
    lowestAwayTeamName: 'Halmstad',
    lowestAwayTeamExtID: 200265,
    lowestDate: '2023-08-07T17:00:00.000Z',
    average: 19861,
    totalHome: 238342,
    totalAway: 149958,
  },
  {
    name: 'Djurgården',
    homeMatch: 12,
    mostSpectators: 26207,
    highestMatch: 'Malmö FF - 2023-07-17',
    highestWeekday: 'Monday',
    highestMatchId: '5391380',
    highestHomeTeamName: 'Djurgården',
    highestHomeTeamExtID: 89483,
    highestAwayTeamName: 'Malmö FF',
    highestAwayTeamExtID: 25517,
    highestDate: '2023-07-17T17:00:00.000Z',
    leastSpectators: 15072,
    lowestMatch: 'Mjällby AIF - 2023-05-21',
    lowestWeekday: 'Sunday',
    lowestMatchId: '5391332',
    lowestHomeTeamName: 'Djurgården',
    lowestHomeTeamExtID: 89483,
    lowestAwayTeamName: 'Mjällby AIF',
    lowestAwayTeamExtID: 25506,
    lowestDate: '2023-05-21T13:00:00.000Z',
    average: 19309,
    totalHome: 231712,
    totalAway: 168153,
  },
  {
    name: 'IFK Göteborg',
    homeMatch: 12,
    mostSpectators: 17875,
    highestMatch: 'BK Häcken - 2023-08-27',
    highestWeekday: 'Sunday',
    highestMatchId: '5391430',
    highestHomeTeamName: 'IFK Göteborg',
    highestHomeTeamExtID: 25508,
    highestAwayTeamName: 'BK Häcken',
    highestAwayTeamExtID: 25509,
    highestDate: '2023-08-27T15:30:00.000Z',
    leastSpectators: 13644,
    lowestMatch: 'Degerfors IF - 2023-05-04',
    lowestWeekday: 'Thursday',
    lowestMatchId: '5391308',
    lowestHomeTeamName: 'IFK Göteborg',
    lowestHomeTeamExtID: 25508,
    lowestAwayTeamName: 'Degerfors IF',
    lowestAwayTeamExtID: 25640,
    lowestDate: '2023-05-04T17:00:00.000Z',
    average: 15950,
    totalHome: 191410,
    totalAway: 133663,
  },
  {
    name: 'IF Elfsborg',
    homeMatch: 12,
    mostSpectators: 14379,
    highestMatch: 'IFK Göteborg - 2023-07-16',
    highestWeekday: 'Sunday',
    highestMatchId: '5391382',
    highestHomeTeamName: 'IF Elfsborg',
    highestHomeTeamExtID: 25504,
    highestAwayTeamName: 'IFK Göteborg',
    highestAwayTeamExtID: 25508,
    highestDate: '2023-07-16T13:00:00.000Z',
    leastSpectators: 5360,
    lowestMatch: 'IF Brommapojkarna - 2023-04-15',
    lowestWeekday: 'Saturday',
    lowestMatchId: '5391272',
    lowestHomeTeamName: 'IF Elfsborg',
    lowestHomeTeamExtID: 25504,
    lowestAwayTeamName: 'IF Brommapojkarna',
    lowestAwayTeamExtID: 25591,
    lowestDate: '2023-04-15T13:00:00.000Z',
    average: 8964,
    totalHome: 107568,
    totalAway: 104312,
  },
  {
    name: 'IFK Norrköping FK',
    homeMatch: 12,
    mostSpectators: 13718,
    highestMatch: 'AIK - 2023-08-21',
    highestWeekday: 'Monday',
    highestMatchId: '5391421',
    highestHomeTeamName: 'IFK Norrköping FK',
    highestHomeTeamExtID: 26935,
    highestAwayTeamName: 'AIK',
    highestAwayTeamExtID: 66036,
    highestDate: '2023-08-21T17:10:00.000Z',
    leastSpectators: 5102,
    lowestMatch: 'Mjällby AIF - 2023-09-18',
    lowestWeekday: 'Monday',
    lowestMatchId: '5391448',
    lowestHomeTeamName: 'IFK Norrköping FK',
    lowestHomeTeamExtID: 26935,
    lowestAwayTeamName: 'Mjällby AIF',
    lowestAwayTeamExtID: 25506,
    lowestDate: '2023-09-18T17:00:00.000Z',
    average: 8580,
    totalHome: 102961,
    totalAway: 135641,
  },
  {
    name: 'Halmstad',
    homeMatch: 12,
    mostSpectators: 10690,
    highestMatch: 'AIK - 2023-04-02',
    highestWeekday: 'Sunday',
    highestMatchId: '5391259',
    highestHomeTeamName: 'Halmstad',
    highestHomeTeamExtID: 200265,
    highestAwayTeamName: 'AIK',
    highestAwayTeamExtID: 66036,
    highestDate: '2023-04-02T15:45:00.000Z',
    leastSpectators: 3872,
    lowestMatch: 'IK Sirius FK - 2023-09-02',
    lowestWeekday: 'Saturday',
    lowestMatchId: '5391439',
    lowestHomeTeamName: 'Halmstad',
    lowestHomeTeamExtID: 200265,
    lowestAwayTeamName: 'IK Sirius FK',
    lowestAwayTeamExtID: 108445,
    lowestDate: '2023-09-02T13:00:00.000Z',
    average: 7061,
    totalHome: 84738,
    totalAway: 75814,
  },
  {
    name: 'Kalmar FF',
    homeMatch: 12,
    mostSpectators: 9326,
    highestMatch: 'AIK - 2023-08-06',
    highestWeekday: 'Sunday',
    highestMatchId: '5391408',
    highestHomeTeamName: 'Kalmar FF',
    highestHomeTeamExtID: 25521,
    highestAwayTeamName: 'AIK',
    highestAwayTeamExtID: 66036,
    highestDate: '2023-08-06T13:00:00.000Z',
    leastSpectators: 4250,
    lowestMatch: 'IK Sirius FK - 2023-05-03',
    lowestWeekday: 'Wednesday',
    lowestMatchId: '5391312',
    lowestHomeTeamName: 'Kalmar FF',
    lowestHomeTeamExtID: 25521,
    lowestAwayTeamName: 'IK Sirius FK',
    lowestAwayTeamExtID: 108445,
    lowestDate: '2023-05-03T17:00:00.000Z',
    average: 6376,
    totalHome: 76518,
    totalAway: 121586,
  },
  {
    name: 'IK Sirius FK',
    homeMatch: 12,
    mostSpectators: 10054,
    highestMatch: 'AIK - 2023-07-31',
    highestWeekday: 'Monday',
    highestMatchId: '5391401',
    highestHomeTeamName: 'IK Sirius FK',
    highestHomeTeamExtID: 108445,
    highestAwayTeamName: 'AIK',
    highestAwayTeamExtID: 66036,
    highestDate: '2023-07-31T17:00:00.000Z',
    leastSpectators: 4021,
    lowestMatch: 'Halmstad - 2023-05-21',
    lowestWeekday: 'Sunday',
    lowestMatchId: '5391336',
    lowestHomeTeamName: 'IK Sirius FK',
    lowestHomeTeamExtID: 108445,
    lowestAwayTeamName: 'Halmstad',
    lowestAwayTeamExtID: 200265,
    lowestDate: '2023-05-21T15:30:00.000Z',
    average: 6301,
    totalHome: 75615,
    totalAway: 80405,
  },
  {
    name: 'BK Häcken',
    homeMatch: 12,
    mostSpectators: 6316,
    highestMatch: 'Hammarby - 2023-04-09',
    highestWeekday: 'Sunday',
    highestMatchId: '5391262',
    highestHomeTeamName: 'BK Häcken',
    highestHomeTeamExtID: 25509,
    highestAwayTeamName: 'Hammarby',
    highestAwayTeamExtID: 66592,
    highestDate: '2023-04-09T13:00:00.000Z',
    leastSpectators: 3112,
    lowestMatch: 'IK Sirius FK - 2023-08-20',
    lowestWeekday: 'Sunday',
    lowestMatchId: '5391423',
    lowestHomeTeamName: 'BK Häcken',
    lowestHomeTeamExtID: 25509,
    lowestAwayTeamName: 'IK Sirius FK',
    lowestAwayTeamExtID: 108445,
    lowestDate: '2023-08-20T13:00:00.000Z',
    average: 4710,
    totalHome: 56520,
    totalAway: 111671,
  },
  {
    name: 'Degerfors IF',
    homeMatch: 13,
    mostSpectators: 5880,
    highestMatch: 'AIK - 2023-05-20',
    highestWeekday: 'Saturday',
    highestMatchId: '5391339',
    highestHomeTeamName: 'Degerfors IF',
    highestHomeTeamExtID: 25640,
    highestAwayTeamName: 'AIK',
    highestAwayTeamExtID: 66036,
    highestDate: '2023-05-20T13:00:00.000Z',
    leastSpectators: 2594,
    lowestMatch: 'Varbergs BoIS FC - 2023-05-29',
    lowestWeekday: 'Monday',
    lowestMatchId: '5391347',
    lowestHomeTeamName: 'Degerfors IF',
    lowestHomeTeamExtID: 25640,
    lowestAwayTeamName: 'Varbergs BoIS FC',
    lowestAwayTeamExtID: 26111,
    lowestDate: '2023-05-29T17:00:00.000Z',
    average: 4131,
    totalHome: 53708,
    totalAway: 126759,
  },
  {
    name: 'Mjällby AIF',
    homeMatch: 12,
    mostSpectators: 5974,
    highestMatch: 'Djurgården - 2023-07-30',
    highestWeekday: 'Sunday',
    highestMatchId: '5391402',
    highestHomeTeamName: 'Mjällby AIF',
    highestHomeTeamExtID: 25506,
    highestAwayTeamName: 'Djurgården',
    highestAwayTeamExtID: 89483,
    highestDate: '2023-07-30T13:00:00.000Z',
    leastSpectators: 2295,
    lowestMatch: 'Varbergs BoIS FC - 2023-04-03',
    lowestWeekday: 'Monday',
    lowestMatchId: '5391260',
    lowestHomeTeamName: 'Mjällby AIF',
    lowestHomeTeamExtID: 25506,
    lowestAwayTeamName: 'Varbergs BoIS FC',
    lowestAwayTeamExtID: 26111,
    lowestDate: '2023-04-03T17:00:00.000Z',
    average: 3880,
    totalHome: 46563,
    totalAway: 100478,
  },
  {
    name: 'Varbergs BoIS FC',
    homeMatch: 12,
    mostSpectators: 4029,
    highestMatch: 'AIK - 2023-07-17',
    highestWeekday: 'Monday',
    highestMatchId: '5391387',
    highestHomeTeamName: 'Varbergs BoIS FC',
    highestHomeTeamExtID: 26111,
    highestAwayTeamName: 'AIK',
    highestAwayTeamExtID: 66036,
    highestDate: '2023-07-17T17:00:00.000Z',
    leastSpectators: 1529,
    lowestMatch: 'IF Brommapojkarna - 2023-09-03',
    lowestWeekday: 'Sunday',
    lowestMatchId: '5391443',
    lowestHomeTeamName: 'Varbergs BoIS FC',
    lowestHomeTeamExtID: 26111,
    lowestAwayTeamName: 'IF Brommapojkarna',
    lowestAwayTeamExtID: 25591,
    lowestDate: '2023-09-03T15:30:00.000Z',
    average: 2704,
    totalHome: 32456,
    totalAway: 102224,
  },
  {
    name: 'IFK Värnamo',
    homeMatch: 12,
    mostSpectators: 4504,
    highestMatch: 'Malmö FF - 2023-06-10',
    highestWeekday: 'Saturday',
    highestMatchId: '5391362',
    highestHomeTeamName: 'IFK Värnamo',
    highestHomeTeamExtID: 25590,
    highestAwayTeamName: 'Malmö FF',
    highestAwayTeamExtID: 25517,
    highestDate: '2023-06-10T13:00:00.000Z',
    leastSpectators: 920,
    lowestMatch: 'Mjällby AIF - 2023-04-10',
    lowestWeekday: 'Monday',
    lowestMatchId: '5391265',
    lowestHomeTeamName: 'IFK Värnamo',
    lowestHomeTeamExtID: 25590,
    lowestAwayTeamName: 'Mjällby AIF',
    lowestAwayTeamExtID: 25506,
    lowestDate: '2023-04-10T11:00:00.000Z',
    average: 2591,
    totalHome: 31099,
    totalAway: 106031,
  },
  {
    name: 'IF Brommapojkarna',
    homeMatch: 12,
    mostSpectators: 4131,
    highestMatch: 'AIK - 2023-07-01',
    highestWeekday: 'Saturday',
    highestMatchId: '5391370',
    highestHomeTeamName: 'IF Brommapojkarna',
    highestHomeTeamExtID: 25591,
    highestAwayTeamName: 'AIK',
    highestAwayTeamExtID: 66036,
    highestDate: '2023-07-01T13:00:00.000Z',
    leastSpectators: 627,
    lowestMatch: 'Mjällby AIF - 2023-04-24',
    lowestWeekday: 'Monday',
    lowestMatchId: '5391290',
    lowestHomeTeamName: 'IF Brommapojkarna',
    lowestHomeTeamExtID: 25591,
    lowestAwayTeamName: 'Mjällby AIF',
    lowestAwayTeamExtID: 25506,
    lowestDate: '2023-04-24T17:00:00.000Z',
    average: 1870,
    totalHome: 22450,
    totalAway: 116838,
  },
];

export function useSpectatorStats() {
  const [teams, loadingTeams, teamsError] = useTeamLogos();
  const spectators = _.orderBy(data, ['average', 'totalHome'], ['desc']);

  const extendedSpectators = spectators.map((spectator) => {
    const a = Object.keys(teams)
      .map((x) => teams[x])
      ?.find((t) => stringSimilarity(t.name, spectator.name) > 0.7);

    return {
      ...spectator,
      logoImageUrl: a?.logoImageUrl,
      teamName: a?.name,
    };
  });

  return [extendedSpectators, false, null];
}
